import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '../ui/dialog';
import { Upload, Plus, Download } from 'lucide-react';

export const ImportCsvDialog = ({ open, onOpenChange, teacherClasses, importClasse, setImportClasse, importFile, dropzone, onDownloadTemplate, onImport }) => {
  const { getRootProps, getInputProps, isDragActive } = dropzone;
  return (
          <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogTrigger asChild>
              <Button data-testid="import-csv-btn" variant="secondary" className="border border-white/5">
                <Upload className="w-4 h-4 mr-2" /> Import CSV
              </Button>
            </DialogTrigger>
            <DialogContent className="bg-card border-border">
              <DialogHeader>
                <DialogTitle>Importer des élèves (CSV)</DialogTitle>
              </DialogHeader>
              <div className="space-y-4">
                <div>
                  <Label>Classe</Label>
                  {teacherClasses.length > 0 ? (
                    <Select value={importClasse} onValueChange={setImportClasse}>
                      <SelectTrigger data-testid="import-classe-select"><SelectValue placeholder="Sélectionnez une classe" /></SelectTrigger>
                      <SelectContent>
                        {teacherClasses.map(tc => (
                          <SelectItem key={tc.class_id} value={tc.nom}>{tc.nom}</SelectItem>
                        ))}
                      </SelectContent>
                    </Select>
                  ) : (
                    <Input
                      data-testid="import-classe-input"
                      placeholder="ex: 3ème A"
                      value={importClasse}
                      onChange={(e) => setImportClasse(e.target.value)}
                    />
                  )}
                </div>
                <div
                  {...getRootProps()}
                  className={`border-2 border-dashed rounded-lg p-8 text-center cursor-pointer transition-colors ${isDragActive ? 'border-primary bg-primary/5' : 'border-border hover:border-primary/50'}`}
                  data-testid="csv-dropzone"
                >
                  <input {...getInputProps()} />
                  <Download className="w-8 h-8 mx-auto mb-2 text-muted-foreground" />
                  {importFile ? (
                    <p className="text-sm">{importFile.name}</p>
                  ) : (
                    <p className="text-sm text-muted-foreground">
                      Glissez un CSV ici ou cliquez pour sélectionner<br />
                      <span className="text-xs">Format: prenom,nom</span>
                    </p>
                  )}
                </div>
                <button
                  type="button"
                  onClick={onDownloadTemplate}
                  className="text-xs text-primary hover:underline flex items-center gap-1"
                  data-testid="download-csv-template"
                >
                  <Download className="w-3 h-3" /> Télécharger le modèle CSV (séparateur , ou ; accepté)
                </button>
                <Button data-testid="import-submit-btn" onClick={onImport} className="w-full bg-primary text-primary-foreground hover:bg-blue-600">
                  Importer
                </Button>
              </div>
            </DialogContent>
          </Dialog>
  );
};

export const AddStudentDialog = ({ open, onOpenChange, teacherClasses, form, setForm, onAdd }) => (
          <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogTrigger asChild>
              <Button data-testid="add-student-btn" className="bg-primary text-primary-foreground hover:bg-blue-600">
                <Plus className="w-4 h-4 mr-2" /> Ajouter
              </Button>
            </DialogTrigger>
            <DialogContent className="bg-card border-border">
              <DialogHeader>
                <DialogTitle>Ajouter un élève</DialogTitle>
              </DialogHeader>
              <div className="space-y-4">
                <div>
                  <Label>Prénom</Label>
                  <Input data-testid="add-prenom" value={form.prenom} onChange={(e) => setForm(p => ({ ...p, prenom: e.target.value }))} />
                </div>
                <div>
                  <Label>Nom</Label>
                  <Input data-testid="add-nom" value={form.nom} onChange={(e) => setForm(p => ({ ...p, nom: e.target.value }))} />
                </div>
                <div>
                  <Label>Classe</Label>
                  {teacherClasses.length > 0 ? (
                    <Select value={form.classe} onValueChange={(v) => setForm(p => ({ ...p, classe: v }))}>
                      <SelectTrigger data-testid="add-classe-select"><SelectValue placeholder="Sélectionnez une classe" /></SelectTrigger>
                      <SelectContent>
                        {teacherClasses.map(tc => (
                          <SelectItem key={tc.class_id} value={tc.nom}>{tc.nom}</SelectItem>
                        ))}
                      </SelectContent>
                    </Select>
                  ) : (
                    <Input data-testid="add-classe" placeholder="ex: 3ème A" value={form.classe} onChange={(e) => setForm(p => ({ ...p, classe: e.target.value }))} />
                  )}
                </div>
                <Button data-testid="add-submit-btn" onClick={onAdd} className="w-full bg-primary text-primary-foreground hover:bg-blue-600">
                  Ajouter
                </Button>
              </div>
            </DialogContent>
          </Dialog>
);
